$(document).ready(function(){
  runWhenLoadingProducts()
  hideColorOptions()
})

function runWhenLoadingProducts(){
  //Asegurarse de que el input es seleccionado al clickear un label
  $(document).on('click', '.product-card label', function(){
      $(this).prev("input").prop("checked", true);
  });
  $(document).on('click', '.product-card .product-option__label', function(){
    if($(this).attr('mainName') == 'COLOR'){
      PCmp_update_sizes($(this).attr('product'),$(this).attr('secondproduct'));
      PCupdateImages($(this).attr('product'),$(this).attr('secondproduct'))
    }
    PChandleVariantClick($(this).attr('product'));
    if($(this).attr('mainName') == 'TALLA'){
      $('product-card[productid="'+$(this).attr('product')+'"] button[type="submit"]').click()
    }
  });
}

function PChandleVariantClick(productId) {
  let color = $('product-card[productid="'+productId+'"] input.color_input:checked').next("label").attr('secondproduct')
  let size = $('product-card[productid="'+productId+'"] input[secondname="TALLA"]:checked').val()
  console.log(color+' - '+size)
  PCmp_select_variant(color,size,productId);
}

function PCmp_select_variant(color,size,productId){
  let variantsInfo = JSON.parse(document.getElementById('variants_data_'+productId).textContent);
  for(const variant of variantsInfo){
    if(color == variant.product && size == variant.title){
      if(variant.available){
        $('product-card[productid="'+productId+'"] button[type="submit"]').removeClass('disabled')
      }
      $('product-card[productid="'+productId+'"] input[name="id"]').val(variant.id)
      PCupdatePrice(productId,variant)
    }
  }
}

function PCupdateImages(productId,variantId){
  $('product-card[productid="'+productId+'"] .media img').addClass('hidden')
  $('product-card[productid="'+productId+'"] .media img').removeClass('activeImage1')
  $('product-card[productid="'+productId+'"] .media img').removeClass('activeImage2')
  $('product-card[productid="'+productId+'"] .media img.pid-img-'+variantId).removeClass('hidden')
  $('product-card[productid="'+productId+'"] .media img.pid-img-'+variantId).eq(0).addClass('activeImage1')
  $('product-card[productid="'+productId+'"] .media img.pid-img-'+variantId).eq(1).addClass('activeImage2')
}

// moneda_pais_pdps $currency : K-UX
function PCupdatePrice(productId,variant){
  const $card = $('product-card[productid="' + productId + '"]');
  const $priceContainer = $card.find('.price__container');
  const currency = $priceContainer.data('currency');
  if(variant.compare_at_price){
  const discount = variant.compare_at_price
  ? -Math.ceil(
      Math.abs(
        ((parseFloat(variant.price.replace(/[^\d.]/g, '')) -
          parseFloat(variant.compare_at_price.replace(/[^\d.]/g, ''))) /
          parseFloat(variant.compare_at_price.replace(/[^\d.]/g, ''))) *
          100
      )
    )
  : 0;
  discountHTML = `
    <span class="product-descuento-pdps js-discount-badge" aria-hidden="true">
      ${discount}%
    </span>
  `;
    $('product-card[productid="'+productId+'"] .price').addClass('price--on-sale')
    $('product-card[productid="'+productId+'"] .price__container').html(`<div class="price__sale">
      <div class="price__sale-inner 6">
      <ins><span class="visually-hidden">Precio mínimo</span>
          <span>${variant.price}<span>&nbsp;${currency}</span></span>
          
          <span aria-hidden="true"></span>
          <span class="visually-hidden"></span>
          <span></span>
        </ins>
          ${discountHTML}
        <br>
        <span class="visually-hidden">Precio regular</span>
        <s>${variant.compare_at_price}<span>&nbsp;${currency}</span></s>
        
      </div>
    </div>`)
  }
  else{
    $('product-card[productid="'+productId+'"] .price').removeClass('price--on-sale')
    $('product-card[productid="'+productId+'"] .price__container').html(`<div class="price__regular">
          <span class="visually-hidden">Precio regular</span>
          <span>${variant.price}<span>&nbsp;${currency}</span></span>
        </div>`)
  }
}

function PCmp_update_sizes(productId,variantId){
  let variantsInfo = JSON.parse(document.getElementById('variants_data_'+productId).textContent);
  for(const variant of variantsInfo){
    if(variantId == variant.product){
      if(variant.available){
        $('product-card[productid="'+productId+'"] input[secondname="TALLA"][value="'+variant.title+'"]').prop('disabled',false)
      }
      else{
        $('product-card[productid="'+productId+'"] input[secondname="TALLA"][value="'+variant.title+'"]').prop('disabled',true)
        if($('product-card[productid="'+productId+'"] input[secondname="TALLA"][value="'+variant.title+'"]').prop("checked")){
          $('product-card[productid="'+productId+'"] button[type="submit"]').addClass('disabled')
        }
      }
    }
  }
}

function hideColorOptions(){
	$('.product__variant-options').on("mouseover",function(){
		if($(this).find(".more-elements")){
			$(this).find(".extra-element").each(function(){
				$(this).css('display','block')
			})
			$(this).find(".more-elements").css('display','none')
		}
	})
	$('.product__variant-options').on("mouseout",function(){
		if($(this).find(".more-elements")){
			$(this).find(".extra-element").each(function(){
				$(this).css('display','none')
			})
			$(this).find(".more-elements").css('display','block')
		}
	})
}